import UmbracoApiService from '@shared/_legacy/services/UmbracoApiService';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EventMaterialDTO } from '@shared/_legacy/api/umbraco-api';

export const useFetchEventMaterial = (eventId?: string, enabled?: boolean, queryOptions?: UseQueryOptions<EventMaterialDTO[]>) => {
    const { data: eventMaterial, ...query } = useQuery<EventMaterialDTO[]>({
        queryFn: () => UmbracoApiService.getUmbracoApiContentGetEventMaterial({ eventId: eventId }),
        queryKey: ['eventMaterial', eventId],
        refetchOnWindowFocus: false,
        enabled,
        ...queryOptions,
    });
    return { eventMaterial, ...query };
};
